import React, { Fragment, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Link,
  makeStyles,
} from "@material-ui/core";
import { Button } from "react-admin";

interface ITemplateUploadStudentSubsidyButton {
  isDisabled?: boolean;
}

const useStyles = makeStyles({
  dialog: {
    "& .MuiDialog-paper": {
      overflowY: "unset",
    },
  },
  cancelButton: {
    backgroundColor: "#eeeeee",
    color: "black",
  },
  leftButton: {
    marginRight: "auto",
  },
  olSpacing: {
    paddingLeft: "20px",
    marginTop: 0,
    marginBottom: 0,
  },
  liSpacing: {
    marginBottom: "10px",
  },
});

const TemplateUploadStudentSubsidyButton = ({
  isDisabled,
}: ITemplateUploadStudentSubsidyButton) => {
  const [open, setOpen] = useState<boolean>(false);
  const classes = useStyles();

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Fragment>
      <Button
        label="Download Template Student Subsidy Setting"
        onClick={handleOpenDialog}
        disabled={isDisabled}
        className={classes.leftButton}
      />

      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          Template Import Mass Import Student Subsidy Setting
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText color="initial">
            <ol className={classes.olSpacing}>
              <li className={classes.liSpacing}>
                You can download template for upload mass credit notes to system
                in this link below.
                <br />
                <Link href="https://jane-prod-storage.s3.ap-southeast-1.amazonaws.com/templates/Template+Import+Student+Subsidy+Setting.xlsx">
                  Template Import Student Subsidy Setting.xlsx
                </Link>
              </li>
              <li className={classes.liSpacing}>
                In the <strong>studentIdentifierType</strong> column, enter:
                <ul className={classes.olSpacing}>
                  <li className={classes.liSpacing}>
                    <strong>studentId</strong> if you will use studentId in the
                    studentIdentifier column.
                  </li>
                  <li className={classes.liSpacing}>
                    <strong>studentExternalId</strong> if you will use
                    studentExternalId in the studentIdentifier column.
                  </li>
                </ul>
              </li>
              <li className={classes.liSpacing}>
                Fill in the <strong>studentIdentifier</strong> column with the
                appropriate value based on what you chose in the
                studentIdentifierType column.
              </li>
              <li className={classes.liSpacing}>
                After fill the sheet, export document to CSV format, then upload
                the document.
              </li>
            </ol>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            color="secondary"
            label="Back"
            className={classes.cancelButton}
          />
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default TemplateUploadStudentSubsidyButton;
